import React, { useEffect, useState } from 'react';
import { Bar } from "react-chartjs-2";
import {
 Chart,
 CategoryScale,
 LinearScale,
 BarElement,
 Tooltip,
 Legend,
} from "chart.js";

Chart.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const PromotionsDrawsPrizesStatisticsChart = ({ r_data }) => {
 const [pageData, setPageData] = useState(r_data);

 useEffect(() => {
  setPageData(r_data);
 }, [r_data]);

 const dataArray = pageData || [];

 const labels = dataArray.map(item => item.prize);
 const values = dataArray.map(item => item.count);

 const data = {
  labels,
  datasets: [
   {
    label: "Prize Distribution",
    data: values,
    backgroundColor: [
     "rgba(37, 150, 190, 0.7)",
     "rgba(235, 100, 89, 0.7)",
     "rgba(255, 193, 7, 0.7)",
     "rgba(40, 167, 69, 0.7)"
    ],
    borderRadius: 6
   }
  ]
 };

 return (
  <div style={{ height: "300px" }}>
   <Bar
    data={data}
    options={{
     indexAxis: "y", // 👈 THIS makes it horizontal
     plugins: {
      legend: { display: false },
      tooltip: {
       callbacks: {
        label: (context) => `${context.parsed.x}`
       }
      }
     },
     maintainAspectRatio: false,
     scales: {
      x: {
       beginAtZero: true,
       ticks: { color: "#9eaecf" },
       grid: { color: "rgba(82, 100, 132, 0.2)" }
      },
      y: {
       ticks: { color: "#9eaecf" },
       grid: { display: false }
      }
     }
    }}
   />
  </div>
 );
};

export default PromotionsDrawsPrizesStatisticsChart;